document.addEventListener("DOMContentLoaded", () => {
  /*
    Variables coming in from template:
    - mapboxgl.accessToken
      Access token set in theme options in backend
    - mapCenter
      Center point of map
    - mapZoom
      Starting zoom level
    - pinIcons
      Array of images used for pins in map 
    - mapStyles
      Array of available style set in theme options
  */

  // Adds pin icon files for map
  function addIcons(icons, map) {
    for (const icon of icons) {
      map.loadImage(
        icon.image, (error, image) => {
          if (error) throw error;
          map.addImage(icon.name, image);
        }
      );
    }
  } // END addIcons

  // Adds new source to map
  function addMapSource(data, map) {
    map.addSource(data.properties.sourcename, {
      type: 'geojson',
      data: data
    });
  } // END addMapSource

  // Adds sources and stretched icon pins to map
  function addSourceStretchedPins(data, map) {
    // console.log('addSourceStretchedPins', data);
    var layerID = data.properties.sourcename;

    // Add data source
    addMapSource(data, map);

    if (!map.getLayer(layerID)) {
      // Add new layer
      map.addLayer({
        'id': layerID,
        'type': 'symbol',
        'source': layerID,
        'layout': {
          'icon-image': data.properties.icon,
          'icon-text-fit': 'both',
          'icon-text-fit-padding': [0, 2, 0, 2],
          'icon-allow-overlap': true,
          // 'icon-ignore-placement': true,
          // 'text-ignore-placement': true,
          'text-field': ['get', 'name'],
          'text-size': 9,
          'text-transform': 'uppercase',
          'text-font': [
            'Arial Unicode MS Bold',
            'Open Sans Semibold',
          ],
          'visibility': data.properties.visible ? 'visible' : 'none'
        },
        'paint': {
          'text-color': '#766410',
          // 'text-halo-color': 'rgba(0, 0, 0, 0.7)',
          // 'text-halo-width': 1
        }
      });
    }
  } // END addSourceStretchedPins

  // Adds sources and standard icon pins to map
  function addSourcePins(data, map) {
    var layerID = data.properties.sourcename;

    // Add data source
    addMapSource(data, map);

    if (!map.getLayer(layerID)) {
      // Add new layer
      map.addLayer({
        'id': layerID,
        'type': 'symbol',
        'source': layerID,
        'layout': {
          'icon-image': data.properties.icon,
          'icon-size': 0.16,
          'icon-ignore-placement': true,
          'text-ignore-placement': false,
          'text-field': data.properties.showText == true ? ['get', 'name'] : '',
          'text-size': 12,
          'text-font': [
            'Open Sans Semibold',
            'Arial Unicode MS Bold'
          ],
          'text-offset': [0, 1],
          'text-max-width': 6,
          'text-anchor': 'top',
          'visibility': data.properties.visible ? 'visible' : 'none'
        },
        'paint': {
          'text-color': 'rgb(255, 255, 255)',
          'text-halo-color': 'rgba(0, 0, 0, 0.7)',
          'text-halo-width': 1
        }
      });
    }
  } // END addSourcePins

  // Adds static data from geojson files
  function addStaticTrails(data, map) {
    // console.log('addStaticTrails', data, map);
    for (const trail of data) {
      // Add data set
      map.addSource(trail.id, {
        type: 'geojson',
        data: trail.file
      });

      // Add trail lines
      map.addLayer({
        'id': trail.id+'_line',
        'type': 'line',
        'source': trail.id,
        'layout': {
          'line-join': 'round',
          'line-cap': 'round',
        },
        'paint': {
          'line-color': trail.color,
          'line-width': 1.25,
        },
        'layout': {
          'visibility': trail.visible ? 'visible' : 'none'
        }
      });

      if (trail.showLabel) {
        // Add trail line label
        map.addLayer({
          'id': trail.id+'_label',
          'type': 'symbol',
          'source': trail.id,
          'layout': {
            'symbol-placement': 'line',
            'symbol-spacing': 200,
            'icon-allow-overlap': true,
            'icon-ignore-placement': true,
            'text-font': ['Open Sans Bold'],
            'text-field': trail.name,
            'text-size': 12,
            'visibility': trail.visible ? 'visible' : 'none'
          },
          'properties': {
            'title': 'aaaaaa'
          },
          'paint': {
            'text-halo-color': '#fff',
            'text-halo-width': 1
          }
        });
      }
    }
  } // END addStaticTrails

  // Add mapbox tileset
  function addTileset(data, map) {
    // console.log('addTileset', data);
    for (const tileset of data) {
      map.addSource(tileset.id, {
        'type': 'raster',
        'url': 'mapbox://'+tileset.tilesetid
      });
      map.addLayer({
        'id': tileset.id,
        'source': tileset.id,
        'type': 'raster',
        'layout': {
          'visibility': tileset.visible ? 'visible' : 'none'
        },
        'paint': {
          'raster-opacity': 0.8
        }
      });
    }
  }

  function buildCheckList(el, map) {
    const input = document.createElement('input');
    input.type = 'checkbox';
    input.classList = 'btn-check';
    input.autocomplete = 'off';

    const label = document.createElement('label');
    label.classList = 'btn btn-outline-primary btn-sm text-start';

    if (typeof pins_intersections !== 'undefined') {
      const intInput = input.cloneNode(true);
        intInput.id = 'intPinsInput';
        intInput.value = pins_intersections.properties.sourcename;
      const intLabel = label.cloneNode(true);
        intLabel.htmlFor = 'intPinsInput';
        intLabel.innerHTML = 'Trail Intersections';

      if (pins_intersections.properties.visible) {
        intInput.checked = true;
      }
      intInput.onchange = (e) => {
        map.setLayoutProperty(
          e.target.value,
          'visibility',
          e.target.checked ? 'visible' : 'none'
        );
      };
  
      el.appendChild(intInput);
      el.appendChild(intLabel);
    }
  
    if (typeof pins_parking !== 'undefined') {
      const parkInput = input.cloneNode(true);
        parkInput.id = 'parkPinsInput';
        parkInput.value = pins_parking.properties.sourcename;
      const parkLabel = label.cloneNode(true);
        parkLabel.htmlFor = 'parkPinsInput';
        parkLabel.innerHTML = 'Parking Lots';

      if (pins_parking.properties.visible) {
        parkInput.checked = true;
      }
      parkInput.onchange = (e) => {
        map.setLayoutProperty(
          e.target.value,
          'visibility',
          e.target.checked ? 'visible' : 'none'
        );
      };
      
      el.appendChild(parkInput);
      el.appendChild(parkLabel);
    }

    if (typeof trail_photos !== 'undefined') {
      const trailImgInput = input.cloneNode(true);
        trailImgInput.id = 'trailImgInput';
        trailImgInput.value = trail_photos.properties.sourcename;
      const trailImgLabel = label.cloneNode(true);
        trailImgLabel.htmlFor = 'trailImgInput';
        trailImgLabel.innerHTML = 'Trail Photos';

      if (trail_photos.properties.visible) {
        trailImgInput.checked = true;
      }
      trailImgInput.onchange = (e) => {
        for (const mapMarker of photoMarkers) {
          const markerEl = mapMarker.getElement();
          markerEl.style.display = e.target.checked ? 'block' : 'none';
        }
      };
      
      el.appendChild(trailImgInput);
      el.appendChild(trailImgLabel);
    }

    if (typeof poi_pins !== 'undefined') {
      const poiInput = input.cloneNode(true);
        poiInput.id = 'poiInput';
        poiInput.value = poi_pins.properties.sourcename;
      const poiLabel = label.cloneNode(true);
        poiLabel.htmlFor = 'poiInput';
        poiLabel.innerHTML = 'Points of Interest';

      if (poi_pins.properties.visible) {
        poiInput.checked = true;
      }
      poiInput.onchange = (e) => {
        map.setLayoutProperty(
          e.target.value,
          'visibility',
          e.target.checked ? 'visible' : 'none'
        );
      };
      
      el.appendChild(poiInput);
      el.appendChild(poiLabel);
    }
  }

  function addPhotoMarkers(data, map) {
    // console.log('addPhotoMarkers', data);
    // Add data source
    addMapSource(data, map);
    // Create photo markers
    for (const marker of data.features) {
      // Create a DOM element for each marker.
      const size = 20;
      const el = document.createElement('div');
        el.className = 'abc-trail-photo-marker';
        el.style.width = `${size}px`;
        el.style.height = `${size}px`;
        el.style.background = `url(${marker.properties.image}) no-repeat center center`;
        el.style.backgroundSize  = 'cover';
        el.style.display = data.properties.visible ? 'block' : 'none';
        el.dataset.pinTitle = marker.properties.name;
      // Add markers to the map.
      let thisMarker = new mapboxgl.Marker({
        element: el,
        rotationAlignment: 'viewport',
        offset: [0, -size / 2]
      })
        .setPopup(new mapboxgl.Popup({
          // anchor: 'top',
          // offset: [0, -size],
          maxWidth: '250px',
          closeButton: false,
          closeOnClick: true
        })
        .setHTML(`<img src="${marker.properties.imageLg}" class="img-fluid mb-2"><div class="h6">${marker.properties.name}</div>${marker.properties.description != '' ? '<p>'+marker.properties.description+'</p>' : ''}`))
        .setLngLat(marker.geometry.coordinates)
        .addTo(map);

      // Add marker to marker array
      photoMarkers.push(thisMarker);
      // Toggle popup on hover
      const markerEl = thisMarker.getElement();
      markerEl.addEventListener('mouseenter', () => thisMarker.togglePopup());
      markerEl.addEventListener('mouseleave', () => thisMarker.togglePopup());
    }
  }

  function secondsToHms(d) {
    d = Number(d);
    var h = Math.floor(d / 3600);
    var m = Math.floor(d % 3600 / 60);
    // var s = Math.floor(d % 3600 % 60);

    var hDisplay = h > 0 ? h + (h == 1 ? " hr. " : " hrs. ") : "";
    var mDisplay = m > 0 ? m + (m == 1 ? " min." : " min.") : "";
    // var sDisplay = s > 0 ? s + (s == 1 ? " second" : " seconds") : "";
    // return hDisplay + mDisplay + sDisplay;
    return hDisplay + mDisplay;
  }

  function getMiles(meters) {
   return (meters*0.000621371192).toFixed(2);
  }

  function showMapStep(step, map) {
    console.log('showMapStep', step);
    const geojson = {
      type: 'FeatureCollection',
      properties: {},
      features: [
        {
          type: 'Feature',
          geometry: step.geometry
        },
        {
          type: 'Feature',
          geometry: {
            type: 'Point',
            coordinates: step.maneuver.location
          }
        }
      ]
    };

    if (map.getSource('stepData')) {
      // if the stepData already exists on the map, update data
      map.getSource('stepData').setData(geojson);
      map.setLayoutProperty('stepRoute', 'visibility', 'visible');
      map.setLayoutProperty('stepPoints', 'visibility', 'visible');
    } else {
      map.addSource('stepData', {
        type: 'geojson',
        data: geojson
      })
      // otherwise, make a new request
      map.addLayer({
        id: 'stepRoute',
        type: 'line',
        source: 'stepData',
        layout: {
          'line-join': 'round',
          'line-cap': 'round'
        },
        paint: {
          'line-color': '#00403f',
          'line-width': 2,
          // 'line-opacity': 1,
          'line-dasharray': [0, 4, 3]
        }
      });

      map.addLayer({
        'id': 'stepPoints',
        'type': 'circle',
        'source': 'stepData',
        'paint': {
          'circle-radius': 6,
          'circle-color': '#B42222'
        },
        'filter': ['==', '$type', 'Point']
      });
    }
  }

  function displayLegSteps(el, steps, map) {
    // console.log('displayLegSteps', steps, map);
    const stepWrap = document.createElement('div');
    stepWrap.classList = 'list-group small';

    for (const step of steps) {
      const stepDist = getMiles(step.distance) > 0 ? getMiles(step.distance) : null;
      console.log('stepDist', step.maneuver.type);
      const stepItem = document.createElement('button');
      stepItem.classList = 'list-group-item list-group-item-action list-group-item-light d-flex align-items-center';
      stepItem.innerHTML = `${step.maneuver.instruction}${stepDist != null ? '<span class="badge bg-secondary rounded-pill ms-auto">'+stepDist+' mi.</span>' : ''}`;
      stepItem.type = 'button';
      stepItem.onclick = (e) => {
        const activeBtn = stepWrap.querySelector('button.active');
        if (activeBtn) {
          activeBtn.classList.remove('active');
        }
        stepItem.classList.add('active');
        showMapStep(step, map);
      };

      stepWrap.appendChild(stepItem);
    }

    el.appendChild(stepWrap);
  }

  function trailLegDisplay(el, legData, index, map) {
    // console.log('trailLegDisplay', legData, map);
    el.innerHTML = `<p class="mb-2 d-flex align-items-center">
      <span class="fs-5 fw-bold">Leg ${index}</span>
      <span class="badge text-bg-light ms-auto me-1">${getMiles(legData.distance)} miles</span>
      <span class="badge text-bg-light">${secondsToHms(legData.duration)}</span></p>
      <p>${legData.summary}</p>`;

    if (legData.steps) {
      displayLegSteps(el, legData.steps, map);
    }
  }

  function trailInfo(data, map) {
    // console.log('trailInfo', data, map);
    const trailInfoBox = document.getElementById('generatedTrailInfo');
    const trailInfoGeneral = trailInfoBox.querySelector('#trailInfoGeneral');
    const trailLegInfo = trailInfoBox.querySelector('#trailLegInfo');

    const prevLegBtn = trailInfoBox.querySelector('#legPrev');
    const nextLegBtn = trailInfoBox.querySelector('#legNext');

    let legIndex = 1;

    // Reset disabled state
    if (nextLegBtn.classList.contains('disabled')) {
      nextLegBtn.classList.remove('disabled');
    }
    if (!prevLegBtn.classList.contains('disabled')) {
      prevLegBtn.classList.add('disabled');
    }

    prevLegBtn.onclick = (e) => {
      if( legIndex !== 1) {
        legIndex--;
        prevLegBtn.classList.remove('disabled');
      }
      if( legIndex <= data.legs.length) {
        nextLegBtn.classList.remove('disabled');
      }
      if( legIndex === 1) {
        prevLegBtn.classList.add('disabled');
      }
      trailLegDisplay(trailLegInfo, data.legs[legIndex-1], legIndex, map);
    };

    nextLegBtn.onclick = (e) => {
      if( legIndex !== data.legs.length) {
        legIndex++;
        nextLegBtn.classList.remove('disabled');
      }
      if( legIndex >= 1) {
        prevLegBtn.classList.remove('disabled');
      }
      if( legIndex === data.legs.length) {
        nextLegBtn.classList.add('disabled');
      }
      trailLegDisplay(trailLegInfo, data.legs[legIndex-1], legIndex, map);
    };

    if (!trailInfoBox.classList.contains('show')) {
      trailInfoBox.classList.add('show');
      setTimeout(() => {
        trailInfoBox.classList.add('fade');
      }, 50);
    }

    trailInfoGeneral.innerHTML = `<p><strong>Trip Duration:</strong> ${secondsToHms(data.duration)}<br>
      <strong>Trip Distance:</strong> ${getMiles(data.distance)} miles <br>
      <strong>Trip Legs:</strong> ${data.legs.length}</p>
      <hr>`;

    trailLegDisplay(trailLegInfo, data.legs[legIndex-1], legIndex, map);
  }

  async function generateTrail(map) {
    // console.log('generateTrail', map);
    const parkingList = document.getElementById('abcGenTrailsList1');
    const prkSel = Array.prototype.slice.call(parkingList.querySelectorAll('option:checked'),0).map(function(v,i,a) { 
        return [Number(v.dataset.pinLng), Number(v.dataset.pinLat)]; 
    });

    const poiList = document.getElementById('abcGenTrailsList2');
    const poiSel = Array.prototype.slice.call(poiList.querySelectorAll('option:checked'),0).map(function(v,i,a) { 
        return [Number(v.dataset.pinLng), Number(v.dataset.pinLat)]; 
    });

    let coordString = '';

    // console.log('prkSel', prkSel);
    // console.log('poiSel', poiSel);

    if (!prkSel.length || !poiSel.length) {
      alert('Please select a starting point and at least one point of interest.');
      return;
    }

    if (prkSel.length) {
      for (const point of prkSel) {
        coordString = coordString + point[0] + ',' + point[1] + ';';
      }
    }

    if (poiSel.length) {
      // let poiIndex = 0;
      for (const poiPoint of poiSel) {
        // poiIndex++;
        // const sep = poiIndex == poiSel.length ? '' : ';';
        // coordString = coordString + poiPoint.dataset.pinLng + ',' + poiPoint.dataset.pinLat + sep;
        coordString = coordString + poiPoint[0] + ',' + poiPoint[1] + ';';
      }
    }

    coordString = coordString + prkSel[0] + ',' + prkSel[1];

    const query = await fetch(
      `https://api.mapbox.com/directions/v5/mapbox/walking/${coordString}?continue_straight=false&geometries=geojson&overview=full&steps=true&walkway_bias=1&waypoints_per_route=true&access_token=${mapboxgl.accessToken}`,
      { method: 'GET' }
    );
    const json = await query.json();
    const data = json.routes[0];
    const route = data.geometry.coordinates;
    const geojson = {
      type: 'Feature',
      properties: {},
      geometry: {
        type: 'LineString',
        coordinates: route
      }
    };

    // Display trail info
    trailInfo(data, map);

    if (map.getSource('route')) {
      // if the route already exists on the map, update data
      map.getSource('route').setData(geojson);
      map.setLayoutProperty('route', 'visibility', 'visible');
    } else {
      // otherwise, make a new request
      map.addLayer({
        id: 'route',
        type: 'line',
        source: {
          type: 'geojson',
          data: geojson
        },
        layout: {
          'line-join': 'round',
          'line-cap': 'round'
        },
        paint: {
          'line-color': '#2ef1a6',
          'line-width': 6,
          'line-opacity': 0.75
        }
      });
    }

    // Create a 'LngLatBounds' with both corners at the first coordinate.
    const bounds = new mapboxgl.LngLatBounds(
      route[0],
      route[0]
    );
    // Extend the 'LngLatBounds' to include every coordinate in the bounds result.
    for (const coord of route) {
      bounds.extend(coord);
    }

    // let boundsOffset = winWidth > 768 ? [-200, 0] : [0, 0];
    let boundsOffset = [0, 0];

    map.fitBounds(bounds, {
      // bearing: 260,
      // pitch: 40,
      maxZoom: 14,
      offset: boundsOffset,
      padding: 150
    });

    // console.log('data', json);
  }

  // =======================
  // Main Map
  // =======================
  if (document.getElementById('abcMap')) {

    var winWidth = window.innerWidth; // Track viewport width
    var photoMarkers = []; // Holds all photo markers for showing/hiding

    const startZoom = document.body.clientWidth > 768 ? mapZoom : mapZoom -1.25; 

    console.log('startZoom', startZoom);

    const map = new mapboxgl.Map({
      container: 'abcMap', // container ID
      // style: 'mapbox://styles/mapbox/outdoors-v12', // style URL
      style: defaultMapStyle, // style URL
      projection: 'globe',
      zoom: startZoom, // starting zoom
      pitch: 0,
      scrollZoom: false,
      center: mapCenter, // starting position [lng, lat]
      bearing: 0
    });

    // Add map controls
    const mbDirections = new MapboxDirections({
      accessToken: mapboxgl.accessToken,
      unit: 'imperial',
      profile: 'mapbox/walking',
      alternatives: true,
      geometries: 'geojson',
      routePadding: 100,
      controls: {
        profileSwitcher: false
      }
    });
    map.addControl(new mapboxgl.NavigationControl());

    // Add geolocate control to the map.
    map.addControl(
      new mapboxgl.GeolocateControl({
        positionOptions: {
          enableHighAccuracy: true
        },
        trackUserLocation: true, // When active the map will receive updates to the device's location as it changes.
        showUserHeading: true // Draw an arrow next to the location dot to indicate which direction the device is heading.
      })
    );

    window.onresize = (event) => {
      // Update vieport width
      winWidth = window.innerWidth;
    };

    // =======================
    // BEGIN: Style Load Event
    // =======================
    map.on('style.load', () => {
      // ==============================
      // Add Mapbox Tilesets (Overlays)
      // ==============================
      if (typeof overlay_tilesets !== 'undefined' && overlay_tilesets.length) {
        addTileset(overlay_tilesets, map);
      }
      // =================
      // Add all pin icons
      // =================
      if (typeof pinIcons !== 'undefined' && pinIcons.length) {
        addIcons(pinIcons, map);
      }
      // =====================
      // Add intersection pins
      // =====================
      if (typeof pins_intersections !== 'undefined') {
        addSourceStretchedPins(pins_intersections, map);
      }
      // =====================
      // Add parking pins
      // =====================
      if (typeof pins_parking !== 'undefined') {
        addSourcePins(pins_parking, map);
      }
      // =================
      // Add Static Trails
      // =================
      if (typeof static_trails !== 'undefined') {
        addStaticTrails(static_trails, map);
      }
      // =================
      // Add Trail Photos
      // =================
      if (typeof trail_photos !== 'undefined') {
        addPhotoMarkers(trail_photos, map);
      }
      // =================
      // Add POI Pins
      // =================
      if (typeof poi_pins !== 'undefined') {
        addSourcePins(poi_pins, map);
      }

      // ===============================
      // Hillshading & terrain elevation
      // ===============================
      // Check map for hillshading insert layer
      const hillsideInsertLayer = map.getLayer('land-structure-polygon') ?  'land-structure-polygon' : null;
      // Add Hillshading Source
      map.addSource('dem', {
        'type': 'raster-dem',
        'url': 'mapbox://mapbox.mapbox-terrain-dem-v1'
      });
      // Add Hillshading
      map.addLayer(
        {
          'id': 'hillshading',
          'source': 'dem',
          'type': 'hillshade'
        },
        // Insert below land-structure-polygon layer,
        // where hillshading sits in the Mapbox Streets style.
        hillsideInsertLayer
      );
      // Add terrain elevation
      map.setTerrain({
        'source': 'dem',
        'exaggeration': 2.5
      });

      // console.log('style.load layers', map.getStyle().layers);
    }); // END: Style Load event


    // =====================
    // BEGIN: Map Load Event
    // =====================
    map.on('load', () => {

      if (typeof mapStyles !== 'undefined' && mapStyles.length) {
        const styleList = document.getElementById('abdMapStyleList');
        let styleIndex = 0;
        for (const style of mapStyles) {
          const input = document.createElement('input');
            input.id = 'styleRadio'+styleIndex;
            input.name = 'styleRadio';
            input.type = 'radio';
            input.classList = 'btn-check';
            input.autocomplete = 'off';
            if (style.url === defaultMapStyle) {
              input.checked = true;
            }
            input.onclick = (e) => {
              const newStyle = style.url;
              map.setStyle(newStyle);
            };
          const label = document.createElement('label');
            label.classList = 'btn btn-outline-primary btn-sm text-start';
            label.htmlFor = 'styleRadio'+styleIndex;
            label.innerHTML = style.name;
          styleIndex++;
          styleList.appendChild(input);
          styleList.appendChild(label);
        }
      }

      // Build feature list 
      if (typeof pins_intersections !== 'undefined' || 
          typeof pins_parking !== 'undefined' ||
          typeof trail_photos !== 'undefined' ||
          typeof poi_pins !== 'undefined' ) {
        const featureList = document.getElementById('abdMapFeatureList');
        buildCheckList(featureList, map);
      }

      // Build trail list
      if (typeof static_trails !== 'undefined') {
        // Build feature list 
        const trailList = document.getElementById('abdMapTrailsList');
        let trailIndex = 0;
        for (const trail of static_trails) {
          const input = document.createElement('input');
            input.id = 'trailCheck'+trailIndex;
            input.type = 'checkbox';
            input.classList = 'btn-check';
            input.autocomplete = 'off';
            if (trail.visible) {
              input.checked = true;
            }
            input.onclick = (e) => {
              map.setLayoutProperty(
                trail.id+'_line',
                'visibility',
                e.target.checked ? 'visible' : 'none'
              );
              // Check for label layer
              if (map.getLayer(trail.id+'_label')) {
                map.setLayoutProperty(
                  trail.id+'_label',
                  'visibility',
                  e.target.checked ? 'visible' : 'none'
                );
              }
            };
          const label = document.createElement('label');
            label.classList = 'btn btn-outline-primary btn-sm text-start';
            label.htmlFor = 'trailCheck'+trailIndex;
            label.innerHTML = trail.name;

          trailIndex++;

          trailList.appendChild(input);
          trailList.appendChild(label);
        }        
      }

      // Build Overlay list
      if (typeof overlay_tilesets !== 'undefined') {
        // Build feature list 
        const overlayList = document.getElementById('abdMapOverlayList');
        let tilesetIndex = 0;
        for (const tileset of overlay_tilesets) {
          const input = document.createElement('input');
            input.id = 'tileSetCheck'+tilesetIndex;
            input.type = 'checkbox';
            input.classList = 'btn-check';
            input.autocomplete = 'off';
            if (tileset.visible) {
              input.checked = true;
            }
            input.onclick = (e) => {
              map.setLayoutProperty(
                tileset.id,
                'visibility',
                e.target.checked ? 'visible' : 'none'
              );
            };
          const label = document.createElement('label');
            label.classList = 'btn btn-outline-primary btn-sm text-start';
            label.htmlFor = 'tileSetCheck'+tilesetIndex;
            label.innerHTML = tileset.name;
          tilesetIndex++;
          overlayList.appendChild(input);
          overlayList.appendChild(label);
        }        
      }


      // Generated trails parking points
      if (typeof pins_parking == 'object') {
        const parkingList = document.getElementById('abcGenTrailsList1');
        for (const prkPoint of pins_parking.features) {
          const prkOpt = document.createElement('option');
          prkOpt.value = prkPoint.properties.name;
          prkOpt.innerHTML = prkPoint.properties.name;
          prkOpt.dataset.pinLng = prkPoint.geometry.coordinates[0];
          prkOpt.dataset.pinLat = prkPoint.geometry.coordinates[1];

          parkingList.appendChild(prkOpt);
        }
      }

      // Generated trails POI points
      if (typeof poi_pins == 'object') {
        const poiList = document.getElementById('abcGenTrailsList2');
        for (const poiPoint of poi_pins.features) {
          const poiOpt = document.createElement('option');
          poiOpt.innerHTML = poiPoint.properties.name;
          poiOpt.value = poiPoint.properties.name;
          poiOpt.dataset.pinLng = poiPoint.geometry.coordinates[0];
          poiOpt.dataset.pinLat = poiPoint.geometry.coordinates[1];

          poiList.appendChild(poiOpt);
        }
      }
 
      const dynRtBtn = document.getElementById('mapDynamicRoutesBtn');
      if (dynRtBtn) {
        dynRtBtn.onclick = (e) => {
          // console.log('Dynamic Routes submit');
          generateTrail(map);
          if (map.getSource('stepData')) {
            map.setLayoutProperty('stepRoute', 'visibility', 'none');
            map.setLayoutProperty('stepPoints', 'visibility', 'none');
          }
        };
      }

      const dynRtClrBtn = document.getElementById('mapDynamicRoutesClearBtn');
      if (dynRtClrBtn) {
        dynRtClrBtn.onclick = (e) => {
          const trailInfoBox = document.getElementById('generatedTrailInfo');
          trailInfoBox.classList.remove('fade');
          setTimeout(() => {
            trailInfoBox.classList.remove('show');
          }, 50);


          if (map.getSource('route')) {
            map.setLayoutProperty('route', 'visibility', 'none');
          }

          if (map.getSource('stepData')) {
            map.setLayoutProperty('stepRoute', 'visibility', 'none');
            map.setLayoutProperty('stepPoints', 'visibility', 'none');
          }
        };
      }

      const mapDirectionsBtn = document.getElementById('mapControlDirections');
      if (mapDirectionsBtn) {
        mapDirectionsBtn.onclick = (e) => {
          if (mapDirectionsBtn.classList.contains('active')) {
            console.log('active button');
            map.addControl(mbDirections, 'bottom-left');
          } else {
            console.log('inactive buton');
            map.removeControl(mbDirections);
          }
        };
      }


      // When a click event occurs on a feature in the places layer, open a popup at the
      // location of the feature, with description HTML from its properties.
      map.on('click', ['pins-poi'], (e) => {
        // Copy coordinates array.
        const coordinates = e.features[0].geometry.coordinates.slice();
        const description = e.features[0].properties.description;
        const pinLink = e.features[0].properties.link;
        const pinTitle = e.features[0].properties.name;
        const pinImage = e.features[0].properties.imageLg;
        var htmlOutput = '';

        console.log('pinImage', pinImage);
        console.log('pinLink', pinLink);
        console.log('description', description);

        // console.log('pin', e.features[0].properties);

        // Ensure that if the map is zoomed out such that multiple
        // copies of the feature are visible, the popup appears
        // over the copy being pointed to.
        while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
          coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360;
        }

        if (pinImage) {
          const img = '<img class="img-fluid mb-2" src="'+pinImage+'" alt="'+pinTitle+'">';
          htmlOutput = htmlOutput + img;
        }

        if (pinTitle) {
          const title = '<h2 class="h6 mb-1">'+pinTitle+'</h2>';
          htmlOutput = htmlOutput + title;
        }

        if (description != '') {
          htmlOutput = htmlOutput + "<p>"+description+"</p>";
        }

        if (pinLink) {
          const detailsBtn = "<div class='d-grid gap-2'><a class='btn btn-sm btn-outline-primary' href='"+pinLink+"'>More Information</a></div>";
          htmlOutput = htmlOutput + detailsBtn;
        }

        if (htmlOutput != '') {
          new mapboxgl.Popup()
            .setLngLat(coordinates)
            .setHTML(htmlOutput)
            .addTo(map);
        }
      });
    }); // END: Map Load event
  } // END: if #abcMap

});
